import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { routes } from '@/router'

import { CustomerCreate } from './customer-create.component'
import { CustomerDetailContainer } from './customer-detail/customer-detail.container'
import { CustomerHome } from './customer-home.component'

export const CustomerContainer = () => {
  return (
    <Switch>
      <Route exact path={routes.customer.home} component={CustomerHome} />
      <Route exact path={routes.customer.create} component={CustomerCreate} />
      <Route exact path={routes.customer.detail(':selfId')} component={CustomerDetailContainer} />
      <Redirect to={routes.customer.home} />
    </Switch>
  )
}
